import React, { useEffect, useState } from "react"
import { withRouter } from "react-router-dom"
import { useQuery } from "@apollo/client"
import { ACCOUNT_ORDER_QUERY } from "../../../Config/Queries"

import { Layout } from "../../../Components/Layouts/Layout"
import PageTitle from "../../../Components/Layouts/PageTitle"
import styled, { css } from "styled-components"
import { Container, PageLocation } from "../../../styles/styles"
import Accordions from "../../../Components/Accordions"
import SLoding from "../../../Components/Loading"
import Payment from "../../../Components/Order/Account/Order/Detail/Payment"
import Refund from "../../../Components/Order/Account/Order/Detail/Refund"
import { orderinfo } from "../../../Config/Env"
import Product from "../../../Components/Order/Account/Order/Detail/Product"
import ProductOrderProduct from "../../../Components/Order/Account/Order/Detail/ProductOrderProduct"

const SContainer = styled(Container)`
  ${({ theme }) => {
    return css`
      .inner {
        background-color: ${theme.colors.lightgray};
        padding: ${theme.paddings.xl};
      }
    `
  }}
`
const SAccordion = styled(Accordions)`
  ${({ theme }) => {
    return css`
      padding: 0;
    `
  }}
`

function Detail({ history, match, location }) {
  const id = match.params.id

  const [items, setItems] = useState([])

  const { data, loading } = useQuery(ACCOUNT_ORDER_QUERY, {
    fetchPolicy: "network-only",
    variables: { id },
  })

  useEffect(() => {
    if (!loading) {
      const {
        TicketAccountOrderDetail: { ticketProduct, isRefund },
      } = data
      if (isRefund) {
        setItems([
          {
            uuid: "0",
            heading: "결제정보",
            content: <Payment data={data} />,
          },
          {
            uuid: "1",
            heading: "환불정보",
            content: <Refund data={data} />,
          },
          {
            uuid: "2",
            heading: orderinfo.Refund.title,
            content: <div>{orderinfo.Refund.content}</div>,
          },
        ])
      } else {
        setItems([
          {
            uuid: "0",
            heading: "결제정보",
            content: <Payment data={data} />,
          },
          {
            uuid: "1",
            heading: orderinfo.Refund.title,
            content: (
              <div className="orderinfo">{orderinfo.Refund.content}</div>
            ),
          },
        ])
      }
    }
  }, [data, loading])

  if (!loading) {
    const {
      TicketAccountOrderDetail: { ticketProduct, isRefund },
    } = data

    return (
      <Layout isNav={true} isFooter={true}>
        <PageTitle title="구매내역" />
        <SContainer>
          <div className="inner">
            <Product data={data} />
            <ProductOrderProduct data={data} />
          </div>
          <SAccordion
            preExpanded={isRefund ? ["0", "1"] : ["0"]}
            items={items}
          />
        </SContainer>
      </Layout>
    )
  } else {
    return <SLoding />
  }
}

export default withRouter(Detail)
